// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { ProductType } from '../Instruments/ProductType.js'
import { DirectMessageBase } from './DirectMessageBase.ts'
// Мессадж форекс-клиента
export let DirectOrderDialogMessage = function ()
{
    DirectMessageBase.call(this, 0)
    this.dialogId = 0
    this.orderId = null
    this.boundToOrderId = null
    this.price = 0
    this.comment = null
    this.orderType_Renamed_Field = 0
    this.closeTime = null
    this.cancelTime = null
    this.FAccount = null
    this.ProductType = ProductType.General
}

DirectOrderDialogMessage.prototype = Object.create(DirectMessageBase.prototype)

Object.defineProperty(DirectOrderDialogMessage.prototype, 'DialogId', {
    get: function () { return this.dialogId },
    set: function (val) { this.dialogId = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'OrderId', {
    get: function () { return this.orderId },
    set: function (val) { this.orderId = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'BoundToOrderId', {
    get: function () { return this.boundToOrderId },
    set: function (val) { this.boundToOrderId = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'Price', {
    get: function () { return this.price },
    set: function (val) { this.price = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'Comment', {
    get: function () { return this.comment },
    set: function (val) { this.comment = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'OrderType', {
    get: function () { return this.orderType_Renamed_Field },
    set: function (val) { this.orderType_Renamed_Field = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'CloseTime', {
    get: function () { return this.closeTime },
    set: function (val) { this.closeTime = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'CancelTime', {
    get: function () { return this.cancelTime },
    set: function (val) { this.cancelTime = val }
})

Object.defineProperty(DirectOrderDialogMessage.prototype, 'Account', {
    get: function () { return this.FAccount },
    set: function (val) { this.FAccount = val }
})